import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row, Card, CardBody } from "reactstrap";
import { Button, Spinner } from "react-bootstrap";
import axios, { get } from "axios";
import { ToastContainer, toast } from "react-toastify";
import config from "../../../../config";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import Search from "../../../Helper/CustomSearch";
import Breadcrumbs from "../../../Helper/Breadcrumbs";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import AsyncSelect from "react-select/async";
import { MdCloudUpload, MdDownload } from "react-icons/md";
import { FiUpload } from "react-icons/fi";
import { HiOutlineTrash } from "react-icons/hi";
import { FaTimes } from "react-icons/fa";

const KeyVenue = () => {
  const tokenKey = {
    headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") },
  };
  const tokenHeaders = {
    Authorization: "Token " + sessionStorage.getItem("tokenKey"),
  };

  const toastAttr = {
    theme: "colored",
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  };

  const breadcrumbData = [
    { title: "Masters", href: "/masters" },
    { title: "Key Venue", href: "#" },
  ];

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [addModal, setAddModal] = useState(false);
  const [selectedVenues, setSelectedVenues] = useState([]);
  const [addLoading, setAddLoading] = useState(false);

  const [bulkModal, setBulkModal] = useState(false);
  const [csvFile, setCsvFile] = useState(null);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);
  const fileInputRef = useRef(null);

  const [removeModal, setRemoveModal] = useState(false);
  const [selRow, setSelRow] = useState(null);

  const initialData = (searchTerm = "") => {
    setLoading(true);
    const url = searchTerm
      ? `${config.service}/masters/key_venue/?search=${searchTerm}`
      : `${config.service}/masters/key_venue/`;
    get(url, tokenKey)
      .then((res) => {
        const data = res.data.results || res.data;
        setTableData(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch((err) => {
        if (err.response?.status === 401) window.location.href = "/";
        setLoading(false);
      });
  };

  useEffect(() => {
    initialData();
  }, []);

  // Searches all vendor mandaps (not just key venues) to pick a venue to add
  const loadVenueOptions = (inputValue) =>
    new Promise((resolve) => {
      if (!inputValue || inputValue.length < 2) {
        resolve([]);
        return;
      }
      axios
        .get(
          `${config.service}/masters/guest/search_mandap?search=${encodeURIComponent(
            inputValue
          )}`,
          tokenKey
        )
        .then((res) => {
          const results = Array.isArray(res.data)
            ? res.data
            : res.data.results || [];
          resolve(
            results.map((v) => ({
              value: v.id,
              label: `${v.mandap_name || v.name || ""}${
                v.city_name ? " — " + v.city_name : ""
              }`,
              raw: v,
            }))
          );
        })
        .catch(() => resolve([]));
    });

  const handleAddVenue = () => {
    if (!selectedVenues || selectedVenues.length === 0) {
      toast.error("Please select at least one venue", toastAttr);
      return;
    }
    setAddLoading(true);
    const rows = selectedVenues
      .map((v) => {
        const name = (v.raw?.mandap_name || v.label || "").replace(/"/g, '""');
        return `${v.value},"${name}"`;
      })
      .join("\n");
    const csvContent = `venue_id,venue_name\n${rows}`;
    const blob = new Blob([csvContent], { type: "text/csv" });
    const formData = new FormData();
    formData.append("file", blob, "venues.csv");

    axios({
      url: `${config.service}/masters/key_venue/bulk_upload/`,
      method: "post",
      headers: tokenHeaders,
      data: formData,
    })
      .then((res) => {
        const count = res.data?.updated_count ?? selectedVenues.length;
        toast.success(`${count} venue(s) marked as Key Venue successfully`, toastAttr);
        closeAddModal();
        setAddLoading(false);
        initialData();
      })
      .catch((err) => {
        if (err.response?.status === 401) window.location.href = "/";
        toast.error("Failed to add venues", toastAttr);
        setAddLoading(false);
      });
  };

  const handleDownloadTemplate = () => {
    fetch(`${config.service}/masters/key_venue/csv_template/`, {
      headers: tokenHeaders,
    })
      .then((res) => res.blob())
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "key_venue_template.csv";
        a.click();
        URL.revokeObjectURL(url);
      })
      .catch(() => toast.error("Failed to download template", toastAttr));
  };

  const handleBulkUpload = () => {
    if (!csvFile) {
      toast.error("Please select a CSV file", toastAttr);
      return;
    }
    setUploadLoading(true);
    setUploadResult(null);
    const formData = new FormData();
    formData.append("file", csvFile);

    axios({
      url: `${config.service}/masters/key_venue/bulk_upload/`,
      method: "post",
      headers: tokenHeaders,
      data: formData,
    })
      .then((res) => {
        setUploadResult(res.data);
        setUploadLoading(false);
        toast.success(
          `${res.data.updated_count} venue(s) updated successfully`,
          toastAttr
        );
        initialData();
      })
      .catch((err) => {
        if (err.response?.status === 401) window.location.href = "/";
        const msg = err.response?.data?.detail || "Bulk upload failed";
        toast.error(msg, toastAttr);
        setUploadLoading(false);
      });
  };

  const closeBulkModal = () => {
    setBulkModal(false);
    setUploadResult(null);
    setCsvFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const closeAddModal = () => {
    setAddModal(false);
    setSelectedVenues([]);
  };

  const handleRemoveVenue = () => {
    if (!selRow) return;
    setRemoveModal(false);
    setLoading(true);
    axios({
      url: `${config.service}/masters/vendor_mandap/${selRow.id}/`,
      method: "patch",
      headers: { ...tokenHeaders, "Content-Type": "application/json" },
      data: JSON.stringify({ is_key_venue: false }),
    })
      .then(() => {
        toast.success("Removed from Key Venues", toastAttr);
        setSelRow(null);
        initialData();
      })
      .catch((err) => {
        if (err.response?.status === 401) window.location.href = "/";
        toast.error("Failed to remove venue", toastAttr);
        setLoading(false);
      });
  };

  const cols = [
    {
      dataField: "id",
      text: "ID",
      headerStyle: () => ({ width: "80px" }),
    },
    {
      dataField: "mandap_name",
      text: "Venue Name",
      headerStyle: () => ({ width: "240px" }),
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "vendor_name",
      text: "Vendor",
      headerStyle: () => ({ width: "200px" }),
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "city_name",
      text: "City",
      headerStyle: () => ({ width: "150px" }),
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "area_name",
      text: "Area",
      headerStyle: () => ({ width: "150px" }),
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "kae_name",
      text: "KAE",
      headerStyle: () => ({ width: "150px" }),
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "kae_contact_number",
      text: "KAE Contact",
      headerStyle: () => ({ width: "140px" }),
      formatter: (cell) => cell || "-",
    },
    {
      dataField: "id",
      text: "Actions",
      headerStyle: () => ({ width: "80px" }),
      formatter: (cell, row) => (
        <HiOutlineTrash
          title="Remove"
          className="themeColor actionIcon"
          style={{ cursor: "pointer", fontSize: "18px" }}
          onClick={(e) => {
            e.stopPropagation();
            setSelRow(row);
            setRemoveModal(true);
          }}
        />
      ),
    },
  ];

  const options = paginationFactory({
    sizePerPage: 20,
    paginationSize: 3,
    hideSizePerPage: true,
    totalSize: tableData.length,
    hidePageListOnlyOnePage: true,
  });

  return (
    <Container className="vendor">
      <Row>
        <Col md={12} className="contBody">
          <Card>
            <CardBody>
              <div className="card__title pageNav">
                <div className="bold-text">
                  <Breadcrumbs data={breadcrumbData} />
                </div>
              </div>
              <Row className="formBtnsDiv ">
                <Col md={6}>
                  <Button
                    variant="primary"
                    className="mr-2"
                    onClick={() => setAddModal(true)}
                  >
                    Add Venue
                  </Button>
                  <Button
                    variant="success"
                    onClick={() => {
                      setBulkModal(true);
                      setUploadResult(null);
                      setCsvFile(null);
                    }}
                  >
                    Bulk Upload
                  </Button>
                </Col>
                <Col md={4} className="ml-auto">
                  <Search callbackFn={(e) => initialData(e)} />
                </Col>
              </Row>
              <Row
                className="vendorList justify-content-center "
                style={{ minHeight: "80vh" }}
              >
                {loading ? (
                  <div className="text-center">
                    <Spinner animation="border" role="status" size="sm" />
                    <span className="ml-1">Loading...</span>
                  </div>
                ) : (
                  <BootstrapTable
                    bootstrap4
                    wrapperClasses="table-responsive pad-20"
                    data={tableData}
                    columns={cols}
                    keyField="id"
                    containerStyle={{ width: "100%" }}
                    hover
                    noDataIndication="No key venues found"
                    pagination={options}
                  />
                )}
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* Add Venue Modal */}
      <Dialog open={addModal} onClose={closeAddModal} fullWidth maxWidth="sm">
        <DialogTitle>Add Key Venue</DialogTitle>
        <DialogContent style={{ paddingTop: "12px" }}>
          <div style={{ fontWeight: 500, marginBottom: "8px" }}>
            Search Venue
          </div>
          <AsyncSelect
            isMulti
            cacheOptions
            loadOptions={loadVenueOptions}
            onChange={setSelectedVenues}
            value={selectedVenues}
            placeholder="Type venue name to search (min. 2 chars)..."
            isClearable
            closeMenuOnSelect={false}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            noOptionsMessage={({ inputValue }) =>
              inputValue && inputValue.length >= 2
                ? "No venues found"
                : "Type at least 2 characters to search"
            }
          />
          <div style={{ fontSize: "12px", color: "#888", marginTop: "8px" }}>
            Search and select one or more venues to mark them as Key Venues.
          </div>
        </DialogContent>
        <DialogActions>
          <Button variant="secondary" onClick={closeAddModal}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleAddVenue}
            disabled={addLoading || selectedVenues.length === 0}
          >
            {addLoading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              `Add Venue${selectedVenues.length > 1 ? "s" : ""}`
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Bulk Upload Modal */}
      <Dialog
        open={bulkModal}
        onClose={closeBulkModal}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Key Venue Bulk Upload</DialogTitle>
        <DialogContent>
          {/* Step 1 */}
          <div
            style={{
              background: "#f8f9fa",
              borderRadius: "6px",
              padding: "14px",
              marginBottom: "16px",
            }}
          >
            <div style={{ fontWeight: 600, marginBottom: "8px" }}>
              Step 1 — Download Template
            </div>
            <Button variant="outline-primary" onClick={handleDownloadTemplate}>
              <MdDownload style={{ marginRight: "6px", fontSize: "16px" }} />
              Download CSV Template
            </Button>
            <div
              style={{ fontSize: "12px", color: "#666", marginTop: "8px" }}
            >
              Fill in the <strong>venue_id</strong> column with VendorMandap
              IDs. The <em>venue_name</em> column is optional (for reference
              only, not processed by the API).
            </div>
          </div>

          {/* Step 2 */}
          <div
            style={{
              background: "#f8f9fa",
              borderRadius: "6px",
              padding: "14px",
              marginBottom: "16px",
            }}
          >
            <div style={{ fontWeight: 600, marginBottom: "10px" }}>
              Step 2 — Upload Filled CSV
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              <input
                ref={fileInputRef}
                type="file"
                accept=".csv"
                style={{ display: "none" }}
                onChange={(e) => {
                  setCsvFile(e.target.files[0] || null);
                  setUploadResult(null);
                }}
              />
              <Button
                variant="outline-secondary"
                onClick={() => fileInputRef.current && fileInputRef.current.click()}
              >
                <FiUpload style={{ marginRight: "6px" }} />
                Choose File
              </Button>
              <span
                style={{
                  fontSize: "13px",
                  color: csvFile ? "#333" : "#999",
                  wordBreak: "break-all",
                }}
              >
                {csvFile ? csvFile.name : "No file chosen"}
              </span>
            </div>
            <Button
              variant="primary"
              style={{ marginTop: "14px" }}
              onClick={handleBulkUpload}
              disabled={uploadLoading || !csvFile}
            >
              {uploadLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <>
                  <MdCloudUpload
                    style={{ marginRight: "6px", fontSize: "16px" }}
                  />
                  Upload
                </>
              )}
            </Button>
          </div>

          {/* Results */}
          {uploadResult && (
            <div
              style={{
                border: "1px solid #dee2e6",
                borderRadius: "6px",
                padding: "14px",
              }}
            >
              <div
                style={{
                  fontWeight: 600,
                  marginBottom: "10px",
                  fontSize: "14px",
                }}
              >
                Upload Results
              </div>
              <div style={{ marginBottom: "6px", fontSize: "13px" }}>
                <span style={{ color: "#28a745", fontWeight: 500 }}>
                  ✅ Updated:{" "}
                </span>
                {uploadResult.updated_count} venue(s)
                {uploadResult.updated_ids?.length > 0 && (
                  <span style={{ color: "#555", fontSize: "12px" }}>
                    {" "}
                    — IDs: {uploadResult.updated_ids.join(", ")}
                  </span>
                )}
              </div>
              {uploadResult.skipped_not_found?.length > 0 && (
                <div style={{ marginBottom: "6px", fontSize: "13px" }}>
                  <span style={{ color: "#e6a817", fontWeight: 500 }}>
                    ⚠️ Not Found:{" "}
                  </span>
                  {uploadResult.skipped_not_found.join(", ")}
                </div>
              )}
              {uploadResult.invalid_rows?.length > 0 && (
                <div style={{ fontSize: "13px" }}>
                  <span style={{ color: "#dc3545", fontWeight: 500 }}>
                    ❌ Invalid Rows:{" "}
                  </span>
                  {uploadResult.invalid_rows.join(", ")}
                </div>
              )}
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button variant="secondary" onClick={closeBulkModal}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Remove Confirmation */}
      <Dialog open={removeModal} onClose={() => setRemoveModal(false)} maxWidth="sm">
        <DialogTitle>
          Confirm Removal
          <FaTimes
            onClick={() => setRemoveModal(false)}
            className="popup-close"
            title="close"
            style={{ cursor: "pointer", float: "right" }}
          />
        </DialogTitle>
        <DialogContent>
          <div style={{ paddingRight: "30px" }}>
            Remove <strong>{selRow?.mandap_name}</strong> from Key Venues?
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRemoveVenue}>Remove</Button>
          <Button variant="secondary" onClick={() => setRemoveModal(false)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Container>
  );
};

export default KeyVenue;
